import React from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';

// images
import s1 from '../../assets/images/s1.png';
import s2 from '../../assets/images/s2.png';
import s3 from '../../assets/images/s3.png';
import s4 from '../../assets/images/s4.png';
import s5 from '../../assets/images/s5.png';
import s6 from '../../assets/images/s6.png';
import action from '../../assets/images/action.png';
import noRecord from '../../assets/images/cloud-cross.png';
import StatusTag from '../StatusTag';

function checkValue(value) {
  if (isNaN(value)) {
    return 1;
    } else {
    return value;
    }
  }

const GeneralInfo = ({ leads, archiveLead }) => {
	return (
		<div id='tab-1' className='tab-content customizeHeights'>
			<div className='tableInfo groupListingTables'>
				<div className='listTables'>
        {leads && leads.length > 0 && (
					<ul className='individualRow tableHead'>
						<li className='groupHead'>Group Name</li>
						<li className='memberHead'>Member name</li>
						<li className='detailsHead'>Member's friends details</li>
						<li className='requestedHead'>Requested on</li>
						<li className='dateHead'>Date added</li>
						<li className='timeHead'>Time in group</li>
						<li className='statusHead'>Status</li>
						<li className='actionHead'>Action</li>
					</ul>
        )}

					{!leads && (
						<ul className='individualRow noRecordsWraper tableContent'>
							<li className='noRecord messageWrater'>
                <p>No Records found</p>
                <span className="noImageWraper">
                  <img src={noRecord} alt="" />
                </span>
              </li>
						</ul>
					)}

					{leads && leads.length < 1 && (
						<ul className='individualRow noRecordsWraper tableContent'>
							<li className='noRecord messageWrater'>
                <p>No Records found</p>
                <span className="noImageWraper">
                  <img src={noRecord} alt="" />
                </span>
              </li>
						</ul>
					)}

					{leads &&
						leads.map((lead, i) => {
							return (
								<ul className='individualRow tableContent' key={i}>
									<li className='groupContent'>
										<a
											rel='noreferrer'
											target='_blank'
											href={
												'https://www.facebook.com/groups/' + lead.group?.groupId
											}
										>
											{lead.group?.groupName}
										</a>
									</li>
									<li className='memberContent'>
										<Link to={'/member-details/' + lead._id}>
											{lead.fbuser?.firstName + ' ' + lead.fbuser?.lastName}
										</Link>
									</li>
									<li className='detailsContent'>
										<span className='deyailsWraper'>
											{lead.noOfTotalFriends !== 'Not Found' && (
												<span className='individualSpan one'>
													<span className='detailsSpan_1'>
														<img
															alt='imagegroup'
															src={s1}
															className='spanImg first'
														/>
														{checkValue(lead.noOfTotalFriends)}
													</span>
													<span className='tooltiptext one'>Total Friends</span>
												</span>
											)}
											{lead.noOfOtherGroups !== 'Not Found' && (
												<span className='individualSpan two'>
													<span className='detailsSpan_2'>
														<img
															alt='imagegroup'
															src={s2}
															className='spanImg second'
														/>
													 {checkValue(lead.noOfOtherGroups)}
													</span>
													<span className='tooltiptext two'>Other Groups</span>
												</span>
											)}

											{lead.noOfTotalGroups !== 'Not Found' && (
												<span className='individualSpan three'>
													<span className='detailsSpan_3'>
														<img
															alt='imagegroup'
															src={s3}
															className='spanImg third'
														/>
														<span className="innerTextinfo">{checkValue(lead.noOfTotalGroups)}</span>
													</span>
													<span className='tooltiptext three'>
														Total Groups
													</span>
												</span>
											)}
											{lead.noOfMutualFriends !== 'Not Found' && (
												<span className='individualSpan four'>
													<span className='detailsSpan_4'>
														<img
															alt='imagegroup'
															src={s4}
															className='spanImg fourth'
														/>
														{checkValue(lead.noOfMutualFriends)}
													</span>
													<span className='tooltiptext four'>
														Mutual Friends
													</span>
												</span>
											)}
											{lead.noOfFriendsInGroup !== 'Not Found' && (
												<span className='individualSpan five'>
													<span className='detailsSpan_5'>
														<img
															alt='imagegroup'
															src={s5}
															className='spanImg fifth'
														/>
														{checkValue(lead.noOfFriendsInGroup)}
													</span>
													<span className='tooltiptext five'>
														Friends in Group
													</span>
												</span>
											)}

											{lead.noOfCommonGroups !== 'Not Found' && (
												<span className='individualSpan six'>
													<span className='detailsSpan_6'>
														<img
															alt='imagegroup'
															src={s6}
															className='spanImg sixth'
														/>
														{checkValue(lead.noOfCommonGroups)}
													</span>
													<span className='tooltiptext six'>Common Groups</span>
												</span>
											)}
										</span>
									</li>
									<li className='requestedContent'>{lead.requestDate}</li>
									<li className='dateContent'>{lead.dateAdded}</li>
									<li className='timeContent'>
										{lead.status === 'Approved'
											? moment().diff(
													moment(lead.dateAdded, 'MMMM Do YYYY').format(
														'YYYY-MM-DD'
													),
													'days'
											  ) + ' days'
											: '---'}
									</li>
									{/* <!-- Use pending or cancel classes in place of approved for different status --> */}
									<li className='statusContent'>
										{/*<span
											className={
												'status ' +
												(lead.status === 'Approved'
													? 'approved'
													: lead.status === 'Declined'
													? 'cancel'
													: lead.status === 'Removed'
													? 'pending'
													: '')
											}
										>
											{lead.status}
										</span>*/}
										<StatusTag status={lead.status}/>
									</li>
									<li
										className='actionContent'
										onClick={() => archiveLead(lead._id)}
									>
										<img alt='imagegroup' src={action} className='actionImg' />
									</li>
								</ul>
							);
						})}
				</div>
			</div>
		</div>
	);
};

export default GeneralInfo;

//"611a14e3d95888f987af5823"
